class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.overlay = this.querySelector('#CartDrawer-Overlay');
        this.closeButton = this.querySelector('#CartDrawer-Close');
        this.cartDrawer = this.querySelector('#CartDrawer');
        this.cartDrawerInner = this.querySelector('.cart-drawer__inner');

        const timeline = gsap.timeline({
            paused: true,
            reversed: true,
            // onStart: () => {
            //     this.classList.add('open');
            // },
            // onReverseComplete: () => {
            //     this.classList.remove('open');
            // }
        });
        this.tl = timeline

        this.animate();
        this.setupRTLListener();
        this.eventListeners();
        this.setHeaderCartElementAccessiblity();
    }

    setHeaderCartElementAccessiblity() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');

        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartLink)
        });

        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    setupRTLListener() {
        window.addEventListener('rtlChange', (event) => {
            this.animate(event.detail.isRTL); // Re-run animation with the updated RTL state
        });
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble'
            }
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    animate(isRTL = window.app.isRTL()) {
        this.tl.clear();

        this.tl
            .fromTo(document.querySelector('.cart-drawer__container'),
                {
                    visibility: 'hidden',
                },
                {
                    visibility: 'visible',
                    duration: 0.8,
                    ease: 'power3.inOut'
                }, 0)
            .fromTo(document.querySelector('.cart-drawer__inner'),
                {
                    x: isRTL ? '-110%' : '110%',
                },
                {
                    x: '0%',
                    duration: 0.8,
                    ease: 'power3.inOut'
                }, 0)
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);

        setTimeout(() => {
            this.tl.play();
            this.tl.then(() => {
                const containerToTrapFocus = this.cartDrawer;
                const focusElement = document.querySelector('.cart-drawer__inner') || this.closeButton;
                trapFocus(containerToTrapFocus, focusElement);
            })
        });
        document.body.classList.add('cart-drawer-open', 'overflow-hidden');
    }

    close() {
        this.tl.reverse();
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('cart-drawer-open', 'overflow-hidden');
    }

    renderContents(parsedState) {
        this.cartDrawerInner.classList.contains('is-empty') && this.cartDrawerInner.classList.remove('is-empty');
        this.productId = parsedState.id;

        this.getSectionsToRender().forEach((section => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));

        setTimeout(() => {
            this.addEventListener('keydown', (e) => {
                // Close the cart drawer if the escape key is pressed
                if (e.keyCode === 27) {
                    this.close();
                }
            });
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.querySelector('#CartDrawer-Close').addEventListener('click', this.close.bind(this));
            this.animate();
            this.open();
        });
    }

    eventListeners() {
        this.addEventListener('keydown', (e) => {
            // Close the cart drawer if the escape key is pressed
            if (e.keyCode === 27) {
                this.close();
            }
        });
        this.overlay.addEventListener('click', this.close.bind(this));
        this.closeButton.addEventListener('click', this.close.bind(this));
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);


class CartDrawerContent extends CartForm {
    getSectionsToRender() {
        return [
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.cart-drawer__inner',
            },
        ]
    }
}

customElements.define('cart-drawer-content', CartDrawerContent);